import { ROUTES } from './routes'

export const GEOFENCE_AIRDROP_ROUTES = [
  ROUTES.StakeRswETH,
  ROUTES.DaoVoyage,
  ROUTES.StakeSwETH,
]
export const GEOFENCE_AIRDROP_BLOCKED_COUNTRIES = ['US']
